import React from "react";

const PaymentSummary = ({ paymentSummary, paymentAllocations }) => {
  if (!paymentSummary) return null;

  const { subtotal, grandTotal, totalTaxes, discountType, discountValue } =
    paymentSummary;

  // Helper function to format numbers as currency with the rupee symbol.
  const formatCurrency = (amount) => `₹${Number(amount).toFixed(2)}`;

  // Calculate the total paid using the payment allocations.
  const totalPaid =
    paymentAllocations?.reduce((acc, alloc) => acc + Number(alloc.amount), 0) ||
    0;

  // Calculate the remaining amount.
  const remainingAmount = grandTotal - totalPaid;

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 mt-6">
      <h3 className="text-xl font-bold text-gray-800 flex items-center space-x-2">
        Payment Summary
      </h3>
      <div className="space-y-3">
        <div className="flex justify-between">
          <span className="text-gray-600">Subtotal</span>
          <span className="font-semibold text-gray-800">
            {formatCurrency(subtotal)}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Discount ({discountType})</span>
          <span className="font-semibold text-gray-800">
            {formatCurrency(discountValue)}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">CGST</span>
          <span className="font-semibold text-gray-800">
            {formatCurrency(totalTaxes?.cgst)}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">SGST</span>
          <span className="font-semibold text-gray-800">
            {formatCurrency(totalTaxes?.sgst)}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">IGST</span>
          <span className="font-semibold text-gray-800">
            {formatCurrency(totalTaxes?.igst)}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Total GST</span>
          <span className="font-semibold text-gray-800">
            {formatCurrency(totalTaxes?.totalGST)}
          </span>
        </div>
        <div className="border-t border-gray-300 pt-3 mt-3 flex justify-between">
          <span className="text-gray-700 text-lg">Grand Total</span>
          <span className="font-bold text-gray-900 text-lg">
            {formatCurrency(grandTotal)}
          </span>
        </div>

        {/* Payment Allocation Details */}
        <div className="mt-4">
          <h4 className="text-lg font-semibold text-gray-800 mb-2">
            Payment Allocations
          </h4>
          <div className="space-y-2">
            {paymentAllocations && paymentAllocations.length > 0 ? (
              paymentAllocations.map((allocation) => (
                <div key={allocation.id} className="flex justify-between">
                  <span className="text-gray-600">{allocation.type}</span>
                  <span className="font-semibold text-gray-800">
                    {formatCurrency(allocation.amount)}
                  </span>
                </div>
              ))
            ) : (
              <p className="text-gray-600">No payments made</p>
            )}
            <div className="border-t border-gray-300 pt-2 mt-2 flex justify-between">
              <span className="text-gray-700">Total Paid</span>
              <span className="font-semibold text-gray-800">
                {formatCurrency(totalPaid)}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-700">Remaining Amount</span>
              <span className="font-semibold text-gray-800">
                {formatCurrency(remainingAmount)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSummary;
